// resources/js/notification-init.js

import notificationService from './services/NotificationService';
import PushNotificationService from './services/PushNotificationService';

// Initialize the notification service globally
document.addEventListener('DOMContentLoaded', async () => {
    console.debug('notification-init.js: DOMContentLoaded fired');
    
    // Check if we have a company ID in meta tag
    const companyIdMeta = document.querySelector('meta[name="company-id"]');
    console.debug('notification-init.js: company-id meta tag:', companyIdMeta);
    
    const companyId = companyIdMeta ? parseInt(companyIdMeta.content, 10) : null;
    console.debug('notification-init.js: parsed company ID:', companyId);

    // Only initialize if we have a company ID
    if (companyId) {
        console.debug('Initializing notification service with company ID:', companyId);

        // NotificationService.init() is disabled - browser push notifications
        // are handled via PushNotificationService and service worker.
        // NotificationBell.jsx (BRO-462) now handles SYSTEM notifications only.
        // Browser push for messages is handled separately via service worker.
        // notificationService.init({
        //     companyId,
        //     autoRequestPermission: false
        // });

        // Initialize push notification service (service worker)
        try {
            const pushInitialized = await PushNotificationService.initialize();
            if (pushInitialized) {
                console.debug('Push notification service initialized successfully');
                
                // Check if user has enabled browser notifications
                const preferences = notificationService.notificationPreferences;
                console.debug('Checking auto-subscribe conditions:', {
                    browser_notifications_enabled: preferences.browser_notifications_enabled,
                    permission: notificationService.permission,
                    shouldAutoSubscribe: preferences.browser_notifications_enabled && notificationService.permission === 'granted'
                });
                
                if (preferences.browser_notifications_enabled && notificationService.permission === 'granted') {
                    // Add a small delay on mobile to ensure service worker is fully activated
                    if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                        console.debug('Mobile device detected, waiting 2s for service worker to fully activate...');
                        await new Promise(resolve => setTimeout(resolve, 2000));
                    }
                    
                    // Check if already subscribed to push
                    console.debug('Checking for existing push subscription...');
                    const isSubscribed = await PushNotificationService.isSubscribed();
                    console.debug('Push subscription check result:', isSubscribed);
                    
                    if (!isSubscribed) {
                        // Use force subscribe to ensure clean subscription
                        console.debug('No existing subscription found, calling forceSubscribe for reliable setup');
                        const subscribeResult = await PushNotificationService.forceSubscribe();
                        console.debug('Force subscribe result:', subscribeResult);
                    } else {
                        console.debug('Existing push subscription found and verified');
                    }
                } else {
                    console.debug('Auto-subscribe skipped - conditions not met');
                }
            }
        } catch (error) {
            console.error('Error initializing push notifications:', error);
        }

        // Make notification service globally available for debugging and for other components
        window.BroadcasterNotifications = notificationService;
        window.BroadcasterPushService = PushNotificationService;
    } else {
        console.warn('No company ID found, notification service not initialized');
        console.warn('Still making PushNotificationService available globally for testing');
        
        // Still make services available for testing purposes
        window.BroadcasterNotifications = notificationService;
        window.BroadcasterPushService = PushNotificationService;
    }
});
